/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ReactNode } from "react";
import { MAP_TOOL_BUTTON } from "src/domains/shared/constants/mapToolButton";

const getInnerButtonStyle = (isActive?: boolean) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${MAP_TOOL_BUTTON.ICON_PX}px;
  height: ${MAP_TOOL_BUTTON.ICON_PX}px;
  transition: all 0.2s ease-in-out;

  ${isActive &&
  css`
    color: ${MAP_TOOL_BUTTON.activeIcon};
  `}

  svg {
    transition: all 0.2s ease-in-out;
    ${isActive &&
    css`
      filter: brightness(0) invert(1);
    `}
  }
`;

export const InnerButton = ({
  isActive,
  children,
}: {
  isActive?: boolean;
  children: ReactNode;
}) => {
  return <div css={getInnerButtonStyle(isActive)}>{children}</div>;
};
